import { getPhotosForPhotowall } from 'entities/photos';

Pixlee.module('HorizontalApp.Show', function(Show, App, _Backbone, _Marionette, $) {
    Show.Controller = App.Controllers.Application.extend({
        initialize: function(options) {
            var collectionView, headerView;
            var _this = this;
            var layout = new Show.Layout(options);
            this.listenTo(layout, 'show', function() {
                var photoscollection = getPhotosForPhotowall();
                collectionView = new Show.HorizontalCollection({
                    collection: photoscollection,
                    displayOptions: options.display_options
                });
                layout.collection = photoscollection;
                photoscollection.on('sync', function(_collection, resp) {
                    if (_this.widgetloaded) {
                        return false;
                    }
                    _this.widgetloaded = true;
                    gon.sortType = resp.sortType;

                    var hasTile = options.display_options.headerOptions.end_tile_upload_button_background_showHide;
                    if (collectionView.sly || hasTile) {
                        var rel = collectionView.sly ? collectionView.sly.rel : {};
                        App.commands.execute('opened:horizontal', rel, photoscollection);
                    }
                });
                headerView = new Show.HeaderView({
                    model: App.currentAlbum
                });
                this.show(collectionView, {
                    region: layout.frame
                });
                this.show(headerView, {
                    region: layout.widget_header_region
                });
                if (options.display_options.is_interactive) {
                    var navbarView;
                    if (App.isMobile) {
                        navbarView = App.request('get:navbar:mobile:view', options, photoscollection);
                    } else {
                        navbarView = App.request('get:navbar:view', options, photoscollection);
                    }

                    this.show(navbarView, {
                        region: layout.interactive_region
                    });
                }
            });
            if (gon.previewMode && App.isDesktop) {
                var header_sponserImage_input;

                App.commands.setHandler('stylesheet:generated', function(css, params) {
                    header_sponserImage_input = header_sponserImage_input || params.header_sponserImage_input;
                    if (!_.isFalsy(params.header_sponserImage_input)) {
                        header_sponserImage_input = params.header_sponserImage_input;
                        App.displayOptions.set('header_sponserImage_input', header_sponserImage_input);
                        headerView = new Show.HeaderView({
                            model: App.currentAlbum
                        });
                        _this.show(headerView, {
                            region: layout.widget_header_region
                        });
                    }

                    if (params.widget_photoSize != '250') {
                        collectionView.triggerMethod('reload:sly');
                    }


                    collectionView.triggerMethod('stylesheet:generated');
                });
            }
            this.show(layout, {
                loading: true
            });
        },
    });
});
